import React from "react";

const MarkdownTable = ({ node, ...props }: any) => {
  return (
    <div className="overflow-x-auto my-4">
      <table
        className="min-w-full text-sm text-black bg-transparent border-collapse"
        {...props}
      >
        {props.children}
      </table>
    </div>
  );
};

const MarkdownThead = ({ node, ...props }: any) => (
  <thead className="bg-gray-200 text-black">
    {props.children}
  </thead>
);

const MarkdownTr = ({ node, ...props }: any) => (
  <tr className="hover:bg-gray-100 transition-colors bg-transparent">
    {props.children}
  </tr>
);

const MarkdownTh = ({ node, ...props }: any) => (
  <th className="px-4 py-3 border-b border-gray-300 text-left font-bold">
    {props.children}
  </th>
);

const MarkdownTd = ({ node, ...props }: any) => (
  <td className="px-4 py-3 border-b border-gray-300">
    {props.children}
  </td>
);

export const MarkdownTableComponents = {
  table: MarkdownTable,
  thead: MarkdownThead,
  tr: MarkdownTr,
  th: MarkdownTh,
  td: MarkdownTd,
};
